module.exports = __webpack_public_path__ + "img/traxion-2.2087a863.png";